module.exports = "/_next/static/resources/cca-wide-10e01d46bdc24f6b4abc8b512efbdfc1.png";